import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const VARP = () => {
  return (
    <CardSection id="VARP" title="VARP">
      <Paragraph>
        전체 데이터 집합(모집단) 내에서 얼마나 분산되어 있는지(값이 얼마나 퍼져
        있는지)를 추정합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>VARP(VALUE_1, [VALUE_2, ...])</Paragraph>
        <Ul>
          <Li>
            <b>VALUE_1</b>은 첫 번째 값입니다.
          </Li>
          <Li>
            <b>VALUE_2, ... [선택 사항]</b>은 추가 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>현재 지원 준비중인 함수입니다.</Paragraph>
        {/* <Img src="computeVarP" /> */}
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 숫자 값, 숫자 값이 포함된 열 또는 숫자 값을
          반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          분석 대상 집합이 데이터 포인트의 샘플만을 나타내는 경우에는 <b>VAR</b>
          을 사용합니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
